import React from "react";
import styled from "styled-components";

const TermsContainer = styled.div`
  max-height: ${(props) => (props.isFullPage ? "100%" : "60vh")};
  overflow-y: auto;
  padding: 10px 0;
`;

const TermsSection = styled.div`
  margin-bottom: 20px;
`;

const TermsTitle = styled.h3`
  color: #2c3e50;
  margin-bottom: 10px;
  font-size: 18px;
`;

const TermsList = styled.ul`
  margin-left: 20px;
  margin-bottom: 15px;
`;

const TermsItem = styled.li`
  margin-bottom: 8px;
  line-height: 1.5;
`;

const TermsLink = styled.span`
  color: #084c7c;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #063c62;
  }
`;

const TermsAndConditions = ({ isLink = true }) => {
  const openTermsWindow = () => {
    window.open("/terms-and-conditions", "_blank", "width=900,height=700");
  };

  const TermsContent = () => (
    <TermsContainer>
      <TermsSection>
        <TermsTitle>1. RESERVATIONS</TermsTitle>
        <TermsList>
          <TermsItem>
            1.1. Advance reservation is to be made via telephone or e-mail to
            ensure room availability.
          </TermsItem>
          <TermsItem>
            1.2. Confirmation of booking can be done through Electronic Funds
            Transfer, or through Speed point at reservation desk or by way of
            bank account deposit. No cash shall be accepted.
          </TermsItem>
          <TermsItem>
            1.3. Reservation can be confirmed by way of verified Purchase Order,
            voucher and credit card transactions from reputable organisations.
          </TermsItem>
          <TermsItem>
            1.4. For individuals, payment is mandatory to obtain a confirmed
            reservation.
          </TermsItem>
          <TermsItem>
            1.5. Rates displayed online are not guaranteed until the customer
            receives full confirmation directly from our office on email.
          </TermsItem>
          <TermsItem>
            1.6. Once a rate is selected and transaction is executed by the
            customer, no other rate is applicable either higher or lower.
          </TermsItem>
          <TermsItem>
            1.7. The cost for stay at Isiqalo Guesthouse/Isiqalo Waterfront
            Lodge includes the confirmed room/reservation rate, and applicable
            fees.
          </TermsItem>
          <TermsItem>
            1.8. For international guests, currency conversions are estimates
            and are provided for information purposes only. The billable amount
            on your check-out shall be charged in our local currency.
          </TermsItem>
          <TermsItem>
            1.9. The Guesthouse reserves the right to modify or cancel the
            customer's reservation if it appears, at our sole discretion, that a
            guest is engaged in fraudulent, illegal or other inappropriate
            activity or the reservation is obtained fraudulently or with
            malicious intention, mistake or error.
          </TermsItem>
          <TermsItem>
            1.10. On check-in, reservation is confirmation, the client then
            signs a guest agreement form/event agreement form, and provides a
            copy of valid photo ID, Passport or driving license at the reception
            desk.
          </TermsItem>
          <TermsItem>
            1.11. All promotional rates at the guesthouse are restrictive fares
            and are non-refundable. Please check applicable restrictions on the
            rate while booking. Isiqalo Guesthouse/ Isiqalo Waterfront Lodge
            reserves the right to withdraw and/or amend the promotion without
            any prior notice.
          </TermsItem>
          <TermsItem>
            1.12. In the case of unforeseen, non-availability of pre-booked room
            at the time of arrival, there will be an offer of an alternate
            similar standard room or guesthouse with similar room type at our
            discretion and without any further liability to either party.
          </TermsItem>
          <TermsItem>
            1.13. Check in is after 14:00, unless arranged otherwise, and check
            out is strictly before 10am, later check out may result in an extra
            day charged to an invoice.
          </TermsItem>
          <TermsItem>
            1.14. Rates may change without notice and may vary for special
            events except for confirmed reservation against the advance payment.
          </TermsItem>
          <TermsItem>
            1.15. For functions and events, a refundable breakage insurance fee
            will be charged and paid by the client in cash. If no property/items
            have been damaged/missing the amount will be refunded to the client.
            If there is damage to property/items, the amount will be deposited
            in the guesthouse/lodge account. A 15% damage fee of the full
            function amount will be charged.
          </TermsItem>
          <TermsItem>
            1.16. Reservation for a function/event is confirmed with at least
            25% deposit of the fully quoted amount.
          </TermsItem>
          <TermsItem>
            1.17. 100% of the full amount is to be paid 14 days prior to the
            function/event.
          </TermsItem>
        </TermsList>
      </TermsSection>

      <TermsSection>
        <TermsTitle>2. DISCOUNTS</TermsTitle>
        <TermsList>
          <TermsItem>2.4.1. Discounts shall not be applicable.</TermsItem>
        </TermsList>
      </TermsSection>

      <TermsSection>
        <TermsTitle>2.5 CANCELLATION & REFUNDS</TermsTitle>
        <TermsList>
          <TermsItem>
            <strong>2.5.1. Functions/events/conferencing- external</strong>
          </TermsItem>
          <TermsItem>
            2.5.1.1. 15% cancellation fee of the deposited amount if
            cancellation is more than 90 days prior to the event
          </TermsItem>
          <TermsItem>
            2.5.1.2. 25% cancellation fee of the deposited amount if cancelled
            less than 60 days prior to the event
          </TermsItem>
          <TermsItem>
            2.5.1.3. 50% cancellation fee of the deposited amount if cancelled
            less than 30 days prior to the event
          </TermsItem>
          <TermsItem>
            2.5.1.4. 100% cancellation fee of the deposited amount if cancelled
            less than 14 days prior to the event
          </TermsItem>
          <TermsItem>
            <strong>2.5.2. Accommodation</strong>
          </TermsItem>
          <TermsItem>2.5.2.1. No refund will be applicable.</TermsItem>
          <TermsItem>
            2.5.2.2. Client may be given option to adjust the dates of stay or
            choose different service offering equivalent to the total amount
            paid.
          </TermsItem>
          <TermsItem>
            <strong>2.5.3. Cancellation process</strong>
          </TermsItem>
          <TermsItem>
            On cancellation of refundable booking the refund process will be as
            follows:
          </TermsItem>
          <TermsItem>
            i. Guest to fill in refund claim form accompanied by confirmation of
            banking details, proof of payment and proof of identity.
          </TermsItem>
          <TermsItem>
            ii. Guesthouse Manager to compile a request for refund memo to be
            approved by the DPI & CFO.
          </TermsItem>
        </TermsList>
      </TermsSection>
    </TermsContainer>
  );

  return (
    <>
      {isLink ? (
        <TermsLink onClick={openTermsWindow}>terms and conditions</TermsLink>
      ) : (
        <TermsContent />
      )}
    </>
  );
};

export default TermsAndConditions;
